import React from 'react';
import styles from './styles.module.css';

const NotFound = () => {
	return (
		<div className={styles.container}>
			<p>not found</p>
		</div>
	);
};

export default NotFound;
